<template>
  <v-dialog v-model="dialogData"  @update:model-value="$emit('close')">
    <v-card class="dialog-card-container">

      <!-- TOP ANIMATION -->
      <div class="kuhul-scroll">
        <div class="kuhul-track">
          <div class="kuhul-group">
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
          </div>

          <div class="kuhul-group">
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
          </div>
        </div>
      </div>
      <div   :style="{ backgroundImage: `url('/models/kuhullogo.png')` }" class="img-background">
      </div>
      <div class="form-container pa-5">

         <div class="row">
          <div class="field">
           
            <v-text-field v-model="emailInput.firstName"  variant="solo" class="input-contact" label="FIRSTNAME" />
          </div>

          <div class="field">
        
            <v-text-field v-model="emailInput.lastName" variant="solo"  class="input-contact" label="LASTNAME" />
          </div>
        </div>

         <div class="field">
      
          <v-text-field  v-model="emailInput.email"  variant="solo" class="input-contact" label="EMAIL" />
        </div>

        <div class="field">
          
          <v-textarea  v-model="emailInput.message"  variant="solo" class="input-contact" label="MESSAGE" />
        </div>
  
        </div>
      <div class="button-wrapper">
          <v-btn @click="handleSendEmail" class="button-contact">Send</v-btn>
      </div>
      <div class="button-wrapper">
          <v-btn @click="$emit('close')" class="button-contact">Close</v-btn>
      </div>

      <!-- BOTTOM ANIMATION -->
      <div class="kuhul-scroll">
        <div class="kuhul-track">
          <div class="kuhul-group">
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
          </div>

          <div class="kuhul-group">
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
          </div>
        </div>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>

import emailjs from '@emailjs/browser'


export default {
  name: "FourthSection",
  data: () => ({
    emailInput: {
      firstName : ``,
      lastName: ``,
      email: ``,
      message: ``
    },
    dialogData: false,
  }),
  props: {
    dialog: Boolean
  },
  mounted() {
    this.dialogData = this.dialog;
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    async handleSendEmail() {
      try {
        const response = await emailjs.send(
          'service_xy9zghb',
          'template_3e0ixh9',
          {
            from_name: `${this.emailInput.firstName} ${this.emailInput.lastName}`,
            message: this.emailInput.message,
            reply_to: this.emailInput.email
          },
          'wnC4Q6a6c4M1x-5sT'
        )

        console.log('SUCCESS', response)
        alert('Email envoyé')

        this.$emit("close")

      } catch (error) {
        console.error('EMAILJS ERROR:', error)
        alert('Erreur email', error)
      }
  }
    
  },
  watch: {
    dialog(newVal) {
      this.dialogData = newVal;
    }
  }
};
</script>



<style scoped>
/* CARD */
.dialog-card-container {
width: 100%;
  background: white !important;
  border-radius: 12px !important;
  overflow: hidden;
}

/* FORM */
.form-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 50vh;
}

/* TITLE */
.contact-title {
  color:black;
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 10px;
}

/* ROW (FIRST + LAST NAME) */
.row {
  display: flex;
  gap: 10px;
}

.field {
  flex: 1;
}

.dialog-desktop + .v-overlay__content {
  width: 40vw !important;
  max-width: 40vw !important;
  height: auto !important;
}

@media (max-width: 960px) {

  .v-overlay__content {
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }

}

/* LABEL */
.input-contact-text {

  margin: 5px 0;
  color: black;
}


:deep(.v-overlay__content) {
  transition: all 0.3s ease;
}

@media (min-width: 961px) {
  :deep(.v-overlay__content) {
    width: 40vw !important;
    max-width: 40vw !important;
    height: auto !important;
  }
}

@media (max-width: 960px) {
  :deep(.v-overlay__content) {
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
}

/* INPUTS */
.input-contact {
  color: black !important;
}

.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-contact {
  margin-bottom: 20px;
  width: 70%;
  font-size: 30px;
  height: 80px !important;
  border-radius: 0px !important;
}
/* KUHUL ANIMATION */
.kuhul-scroll {
  position: relative; 
  width: 100%;
  overflow: hidden;
  height: 200px;
  pointer-events: none;
}

.kuhul-track {
  display: flex;
  width: max-content;
  animation: scroll-kuhul 18s linear infinite;
  
}

.kuhul-group {
  background-color: black;
  color: white;
  display: flex;

}

.kuhul-group span {
  font-size: 26px;
  font-weight: bold;
  margin-right: 20px;
  white-space: nowrap;

}

.img-background {
  height: 1000px;
  background-repeat: repeat-x;
  background-size: 100px auto; 
  opacity: 1;
}

@keyframes scroll-kuhul {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}

/* REMOVE ALL DEFAULT FIELD STYLING */
.input-contact .v-field {
  box-shadow: none !important;
   border-radius: 0px !important;
}

.input-contact .v-field__input,
.input-contact .v-field__field {
  background: black !important;
  border-radius: 0px !important;
}

/* REMOVE Vuetify SURFACE LAYERS */
.input-contact .v-field__overlay,
.input-contact .v-field__underlay,
.input-contact .v-field__outline {
  display: none !important;
}

/* REMOVE FOCUS EFFECT */
.input-contact .v-field--focused::before,
.input-contact .v-field--focused::after {
  display: none !important;
}

::v-deep(.input-contact .v-field) {
  border-radius: 0 !important;
}


@media (max-width: 960px) {

  /* Dialog full screen mobile */
  .dialog-card-container {
    width: 100% !important;
    height: 100vh;
    border-radius: 0 !important;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  /* KUHUL animations plus compactes */
  .kuhul-scroll {
    height: 90px;
  }

  .kuhul-group span {
    font-size: 16px;
    margin-right: 12px;
  }

  /* Form spacing */
  .form-container {
    height: auto;
    padding: 20px 15px;
    gap: 12px;
  }

  /* Stack inputs */
  .row {
    flex-direction: column;
    gap: 12px;
  }

  .field {
    width: 100%;
  }

  /* Inputs easier touch */
  .input-contact {
    font-size: 14px;
  }

  /* Button full width (important UX mobile) */
  .button-contact {
    width: 100%;
    height: 60px !important;
    font-size: 18px;
    margin-bottom: 30px;
  }

  /* Background image reduce noise */
  .img-background {
    height: 300px;
    background-size: 80px auto;
    opacity: 0.6;
  }
}


</style>